import { render, staticRenderFns } from "./ProductionWork.vue?vue&type=template&id=53e0b2b8&scoped=true&"
import script from "./ProductionWork.vue?vue&type=script&lang=ts&"
export * from "./ProductionWork.vue?vue&type=script&lang=ts&"
import style0 from "./ProductionWork.vue?vue&type=style&index=0&id=53e0b2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e0b2b8",
  null
  
)

export default component.exports